import { MarkerMerger } from "./MarkerMerger.js";
import { TreeParameterMerger } from "./TreeParameterMerger.js";
import { MarkerFactory } from "../queryLanguage/MarkerFactory.js";
import { EntityFieldMarkersContainer } from "../markers/EntityFieldMarkersContainer.js";
import { EntityFieldsWithHoistablesMarker } from "../markers/EntityFieldsWithHoistablesMarker.js";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class IncrementalMarkerBuilder {
  constructor() {
    __publicField(this, "accumulator", new EntityFieldMarkersContainer(
      false,
      /* @__PURE__ */ new Map(),
      /* @__PURE__ */ new Map()
    ));
  }
  mutateIn(addition) {
    if (addition instanceof EntityFieldMarkersContainer) {
      if (this.accumulator instanceof EntityFieldMarkersContainer) {
        this.accumulator = MarkerMerger.mergeEntityFieldsContainers(this.accumulator, addition);
      } else {
        this.accumulator = new EntityFieldsWithHoistablesMarker(
          MarkerMerger.mergeEntityFieldsContainers(this.accumulator.fields, addition),
          this.accumulator.subTrees,
          this.accumulator.parentReference
        );
      }
    } else if (addition instanceof EntityFieldsWithHoistablesMarker) {
      if (this.accumulator instanceof EntityFieldMarkersContainer) {
        this.accumulator = new EntityFieldsWithHoistablesMarker(
          MarkerMerger.mergeEntityFieldsContainers(this.accumulator, addition.fields),
          addition.subTrees,
          addition.parentReference
        );
      } else {
        this.accumulator = new EntityFieldsWithHoistablesMarker(
          MarkerMerger.mergeEntityFieldsContainers(this.accumulator.fields, addition.fields),
          MarkerMerger.mergeSubTreeMarkers(this.accumulator.subTrees, addition.subTrees),
          TreeParameterMerger.mergeParentEntityParameters(this.accumulator.parentReference, addition.parentReference)
        );
      }
    } else {
      if (this.accumulator instanceof EntityFieldMarkersContainer) {
        this.accumulator = MarkerMerger.mergeEntityFieldsContainers(
          this.accumulator,
          MarkerFactory.createEntityFieldMarkersContainer(addition)
        );
      } else {
        this.accumulator = new EntityFieldsWithHoistablesMarker(
          MarkerMerger.mergeEntityFieldsContainers(
            this.accumulator.fields,
            MarkerFactory.createEntityFieldMarkersContainer(addition)
          ),
          this.accumulator.subTrees,
          this.accumulator.parentReference
        );
      }
    }
  }
  getFinalMarker() {
    return this.accumulator;
  }
}
export {
  IncrementalMarkerBuilder
};
//# sourceMappingURL=IncrementalMarkerBuilder.js.map
